import React, {useEffect, useState, useRef} from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import imgHistoryN from '../img/CompHistory_Name.png';
import '../css/CompHistory.css'
import Text from '../../../common/Text.js';
import imgSample1 from '../img/CompHistory_Img1.png';
// import imgSample2 from '../img/CompHistory_Img2.png';
import imgSample2 from '../img/사업장2.png'
import imgSample3 from '../img/사업장3.png'


// 추후 데이터가 추가되면, (기재 메서드 ctrl + F)
// SOTECTMapper.xml 에 'HistoryDt' 조건에 새년도 추가하기
// getCompHisDataYear1 => 연도별로 범위를 끊어서 데이터 가져오기 (ex 2021 ~ 2025)
// getGroupByYear1 => 연도범위 내에서 연도로 데이터들을 그룹화 (ex 2021 / 2022 / 2023/ ... )
// scrollToYear => 연도별 사이드바에 범위 추가 (ex 사이드바에 2021 - 2025 버튼 추가)
// handleSidebarScroll => 연도별 사이드바 스크롤 이벤트 감지구간 설청 (ex 2021 - 2025 버튼에 활성화될 구간 지정)

function CompHistory() {
    const [Display, setDisplay] = useState('none');
    const [remainingHeight, setRemainingHeight] = useState(0);
    const handleHover = (height) => {
        setRemainingHeight(height);
        console.log('Received Remaining height:', height);
        setDisplay('block');
        console.log('Received Remaining height:', Display);

    };
    const handleHoverEnd = () => {
        console.log('Hover ended in MainComponent');
        setDisplay('none');
    };

    const [DbSelectCompInfoHistory, setDbSelectCompInfoHistory] = useState([]); // 추가
    const [DbSelectCompInfoHistoryYear1, setDbSelectCompInfoHistoryYear1] = useState([]); // 추가
    const [DbSelectCompInfoHistoryYear2, setDbSelectCompInfoHistoryYear2] = useState([]); // 추가
    const [DbSelectCompInfoHistoryYear3, setDbSelectCompInfoHistoryYear3] = useState([]); // 추가
    const [DbSelectCompInfoHistoryYear4, setDbSelectCompInfoHistoryYear4] = useState([]); // 추가

    // 년도별 버튼 사이드바
    const [barPosition, setBarPosition] = useState(300);
    // 년도별 버튼 사이드바 - 색변경
    const [barColor, setBarColor] = useState('2021');

    const [hideElement, setHideElement] = useState(false);
    const scrollRef = useRef(null);

    // 현재 스크롤
    const [scrollTopPosition, setScrollTopPosition] = useState(0);
    
    // 스크롤 영역 내 각 포인트들의 시작위치를 저장
    const [pointPositions, setPointPositions] = useState({});
    
    // 나타내기 애니매이션
    const [isShownYear3, setisShownYear3] = useState(false);
    const [isShownYear2, setisShownYear2] = useState(false);
    const [isShownYaer1, setisShownYear1] = useState(false);

    const [isAVisible, setisAVisible] = useState(true)  
    const [isBVisible, setisBVisible] = useState(false)
    const [isCVisible, setisCVisible] = useState(false)
    
    // 오늘 연도를 동적으로
    const today = new Date();
    // CompanyHistory 전체 List

    /* #region - 메인 데이터 가져오기 */
    useEffect ( () => {
        getCompHisData();
    }, []);

    const getCompHisData = async () => {
        axios.get('/api/CompHistorySelect')
        .then(response => [setDbSelectCompInfoHistory(response.data)])
        //.then(response => [console.log(response.data)])
       .catch(error => console.log(error));
    }

    // CompanyHistory 2021~ 2024
    useEffect ( () => {
        getCompHisDataYear1();
    }, []);

    const getCompHisDataYear1 = async () => {
        axios.get('/api/CompHistorySelectYear1')
        .then(response => [setDbSelectCompInfoHistoryYear1(response.data)])
        // .then(response => [console.log(response.data)])
       .catch(error => console.log(error));
    }

    // CompanyHistory 2012~2020 List
    useEffect ( () => {
        getCompHisDataYear2();
    }, []);

    const getCompHisDataYear2 = async () => {
        axios.get('/api/CompHistorySelectYear2')
        .then(response => [setDbSelectCompInfoHistoryYear2(response.data)])
        //.then(response => [console.log(response.data)])
       .catch(error => console.log(error));
    }

    // CompanyHistory 2012~ List
    useEffect ( () => {
        getCompHisDataYear3();
    }, []);

    const getCompHisDataYear3 = async () => {
        axios.get('/api/CompHistorySelectYear3')
        .then(response => [setDbSelectCompInfoHistoryYear3(response.data)])
        //.then(response => [console.log(response.data)])
       .catch(error => console.log(error));
    }

    // CompanyHistory 1999~2011 List
    useEffect ( () => {
        getCompHisDataYear4();
    }, []);

    const getCompHisDataYear4 = async () => {
        axios.get('/api/CompHistorySelectYear4')
        .then(response => [setDbSelectCompInfoHistoryYear4(response.data)])
        //.then(response => [console.log(response.data)])
       .catch(error => console.log(error));
    }

    // 년도별로 groupby한 데이터들 (2021~ )
    const getGroupByYear1 = DbSelectCompInfoHistoryYear1.reduce((acc, obj) => {
        const {HistoryDt} = obj;
        acc[HistoryDt] = acc[HistoryDt] ?? [];
        acc[HistoryDt].push(obj);
        return acc;
    }, {});

    // 년도별로 groupby한 데이터들 (2012~ )
    const getGroupByYear2 = DbSelectCompInfoHistoryYear2.reduce((acc, obj) => {
        const {HistoryDt} = obj;
        acc[HistoryDt] = acc[HistoryDt] ?? [];
        acc[HistoryDt].push(obj);
        return acc;
    }, {});

    // const getGroupByYear3 = DbSelectCompInfoHistoryYear3.reduce((acc, obj) => {
    //     const {HistoryDt} = obj;
    //     acc[HistoryDt] = acc[HistoryDt] ?? [];
    //     acc[HistoryDt].push(obj);
    //     return acc;
    // }, {});


    // 년도별로 groupby한 데이터들 (1999~ )
    const getGroupByYear4 = DbSelectCompInfoHistoryYear4.reduce((acc, obj) => {
        const {HistoryDt} = obj;
        acc[HistoryDt] = acc[HistoryDt] ?? [];
        acc[HistoryDt].push(obj);
        return acc;
        
    }, {});

    /* #endRegion - 메인 데이터 가져오기 끝 */

//////////////////////////////////////////
    // 특정 요소의 위치 가져오기
    const saTriggerMargin = 300;
    const saElementList = document.querySelectorAll('.sa');

    const saFnc = function () {
        for(const element of saElementList) {
            if (!element.classList.contains('show')) {
                if(window.innerHeight > element.getBoundingClientRect().top + saTriggerMargin) {
                    element.classList.add('show');
                };
            };
        };
    };
    window.addEventListener('scroll', saFnc);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                entry.target.classList.add('show');
            }
        });
    }, {threshold: 0.1});
    // document.querySelectorAll('.HistoryContent1').forEach(el => observer.observe(el));
    document.querySelectorAll('.historytext1').forEach(el => observer.observe(el));



    // 연도별 클릭 이벤트 (클릭한 연도의 연혁내용으로 스크롤 이동)
    const scrollToYear = (num) => {
        const targetElement = document.getElementById(`scrollPoint${num}`);
        if(targetElement) {
            targetElement.scrollIntoView({behavior: 'smooth', block:'start'})
        }
    };


    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if(!scrollRef) return;

        const handleScroll = () => {
            setScrollTopPosition(scrollContainer.scrollTop)
            const points = ['scrollPoint3', 'scrollPoint2', 'scrollPoint1'];
            const positions = {};

            points.forEach(id => {
                const targetElement = document.getElementById(id);
                if(targetElement) {
                    positions[id] = targetElement.offsetTop;
                }
            });
            setPointPositions(positions); 

            const scrollTop = scrollContainer.scrollTop + positions.scrollPoint3;  // 헤더부터 첫 요소까지의 거리만큼 더한다
            // setScrollTopPosition(scrollTop);
            
            if(scrollTop >= 0 && scrollTop < (positions.scrollPoint2 || Infinity)) {
                setBarColor('2021')
                setisAVisible(true)
                setisBVisible(false)
                setisCVisible(false)

                // console.log("현재 point 3 구간");
            } 
            else if(scrollTop >= (positions.scrollPoint2) && scrollTop <= (positions.scrollPoint1 || Infinity)) {
                setBarColor('2012')
                setisAVisible(false)
                setisBVisible(true)
                setisCVisible(false)

                // console.log("현재 point 2 구간");
            } 
            else if (scrollTop >= (positions.scrollPoint1 || 0)) {
                setBarColor('1999')  
                setisAVisible(false)
                setisBVisible(false)
                setisCVisible(true)
                // console.log('현재 point 1 구간');
            }
        };

        scrollContainer.addEventListener('scroll', handleScroll);
        return() => {
            scrollContainer.removeEventListener('scroll', handleScroll);
        };
    }, []);



    // 년도별 버튼 사이드바 스크롤 이벤트 (안씀)
    const handleSidebarScroll = () => {
        console.log('handle method')
        // const position = 1700 < 300 + window.scrollY ? 1700 : 300 + window.scrollY;  // 헤더, 풋터 제외한 범위 내 사이드바 스크롤 되도록
        const position = 1700 < 300 + scrollRef ? 1700 : 300 + window.scrollY;  // 헤더, 풋터 제외한 범위 내 사이드바 스크롤 되도록
        const scrolledTopLength = window.pageYOffset;

        // 각 년도별로 구간위치를 찾아서 동적으로 구현할 수 있게 
        // year3 (2021 ~ 2025)
        const target3 = document.getElementById('scrollPoint3');
        const clientRect3 = target3.getBoundingClientRect();
        console.log(clientRect1);
        const relativeTop3 = clientRect3.top;
        console.log(relativeTop1);
        const absoluteTop3 = scrolledTopLength + relativeTop3 -100;

        // year2 (2012 ~ 2020)
        const target2 = document.getElementById('scrollPoint2');
        const clientRect2 = target2.getBoundingClientRect();
        console.log(clientRect2);
        const relativeTop2 = clientRect2.top;
        console.log(relativeTop2);
        const absoluteTop2 = scrolledTopLength + relativeTop2 -100;

        // year1 (1999 ~ 2011)
        const target1 = document.getElementById('scrollPoint1');
        const clientRect1 = target1.getBoundingClientRect();
        const relativeTop1 = clientRect1.top;
        const absoluteTop1 = scrolledTopLength + relativeTop1 -100;

        setBarPosition(position);
        
            if(position > absoluteTop3 && position < absoluteTop2 ) {
            setBarColor('2021')
            // setisShownYaer3(true)
            setisShownYear1(false)
            setisShownYear2(false)
            setisShownYear3(true)
         }
         else if (position > absoluteTop2 && position < absoluteTop1 ) {
            setBarColor('2012')
            setisShownYear3(false)
            setisShownYear1(false)
            setisShownYear2(true)
            // if(position > absoluteTop2 + 400  && position < absoluteTop1 -200 ) {
            // }
            // else {
                // setisShownYear2(false)
                
            // }
            // else {
            //     setisShownYear2(false)
            // }
         }
         else if (position > absoluteTop1) {
            setBarColor('1999')
            setisShownYear3(false)
            setisShownYear1(true)
            setisShownYear2(false)           
            
         }
        };




     return (
         <div>

            <div className='HistoryMain'>
                {/* <div className='historyYearSidebar' style={ {top : barPosition }}> */}
                <div className='historyYearSidebar' >
                    <Text variant='px18' onClick={() => scrollToYear(3)} className={`scroll ${barColor === '2021' ? 'on' : 'off'}`} >2021 - {today.getFullYear()}</Text>
                    <div className='scrollLine'></div>
                    <Text variant='px18' onClick={() => scrollToYear(2)} className={`scroll ${barColor === '2012' ? 'on' : 'off'}`} >2012 - 2020</Text>
                    <div className='scrollLine'></div>
                    <Text variant='px18' onClick={() => scrollToYear(1)} className={`scroll ${barColor === '1999' ? 'on' : 'off'}`} >1999 - 2011</Text>
                </div>
                <div className='Historyparent1'>
                    <Text variant="titlename" >  
                        <div className='HistoryHello'>회사 연혁</div> 
                    <div className='HistorySub'>고객과 함께 발전하며, 최고의 서비스를 제공하기 위한 노력의 시간</div>
                    </Text>

                </div>
                <div className='historyBody'>
                    {/* <div>현재 스크롤 위치  {scrollTopPosition}</div> */}
                    <div className='historyScroll' ref={scrollRef}  > 
                        <div className='ContentGroup1'  >
                        {!isCVisible && !isBVisible && isAVisible && (
                                <div className="historytext1"  > 
                                    <Text variant='px50w800B' className='HistoryYear'>2021 ~ {today.getFullYear()}</Text>
                                    <div className='HistorySubTitle1'>

                                        <Text variant='px50w600' >위기를 넘어 미래를 선도할 힘찬 항해</Text>
                                    </div>
                                    <div className='imgContainer'>
                                        <img className='img_ch' src={imgSample1}/>
                                    </div>
                                    
                                </div>

                        )}                           

                            <div id='scrollPoint3' className='HistorySectionContainer'> 
                                <div className='HistoryContentWrap'>
                                    <div className='HistoryContent1'>
                                        {Object.entries(getGroupByYear1).sort(([keyA], [keyB])=>parseInt(keyB)-parseInt(keyA)).map((arrays, index) => {
                                            // console.log(getGroupByYear1)
                                            const year = arrays[0];
                                            const isLast = index === arrays[1].length -1;
                                            return <div>
                                                <div className='HistoryRow'>
                                                    <span className='HistoryDate'>
                                                        <Text variant='px20w600' >{year}</Text>
                                                    </span>
                                                    <div className='HisContents_Container'>
                                                        {arrays[1].map(array => {
                                                            return <span className='HistoryContents'>
                                                                    <Text variant='px16w400B' style={{ lineHeight : '12px'}}>{array.Contents}</Text>
                                                                </span>  
                                                        })}
                                                    </div>
                                                </div>
                                                {!isLast && (
                                                    <div className='HisContent_LineContainer'>
                                                            <div className='HisContent_Line'> </div>
                                                    </div>
                                                )}
                                                {/* <div className='HisContent_LineContainer'>
                                                        <div className='HisContent_Line'> </div>
                                                </div> */}
                                            </div>
                                        })}

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='ContentGroup2'>
                            {!isAVisible && !isCVisible && isBVisible && (
                            <div className='historytext1' >
                                <Text variant='px50w800B' className='HistoryYear'>2012 ~ 2020</Text>
                                <div className='HistorySubTitle1'>
                                    <Text variant='px50w600'>종합 엔지니어링 기업을 향한 신사업 추진</Text>
                                </div>
                                    <div className='imgContainer'>
                                        <img src={imgSample2}/>
                                    </div>
                            </div>
                            )

                            }

                            <div id='scrollPoint2' className='HistorySectionContainer'> 
                                <div className='HistoryContentWrap'>
                                    <div className='HistoryContent1'>
                                        {Object.entries(getGroupByYear2).sort(([keyA], [keyB])=>parseInt(keyB)-parseInt(keyA)).map((arrays, index) => {
                                            const year = arrays[0];
                                            const isLast = index === arrays[1].length -1;
                                            return <div>
                                                <div className='HistoryRow'>
                                                    <span className='HistoryDate'>
                                                        <Text variant='px20w600' >{year}</Text>
                                                    </span>
                                                    <div className='HisContents_Container'>
                                                        {arrays[1].map(array => {
                                                            return <span className='HistoryContents'>
                                                                    <Text variant='px16w400B' style={{ lineHeight : '12px'}}>{array.Contents}</Text>
                                                                </span>  
                                                        })}
                                                    </div>
                                                </div>
                                                {!isLast && (
                                                    <div className='HisContent_LineContainer'>
                                                            <div className='HisContent_Line'> </div>
                                                    </div>
                                                )}
                                                {/* <div className='HisContent_LineContainer'>
                                                        <div className='HisContent_Line'> </div>
                                                </div> */}
                                            </div>
                                        })}
                                        

                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className='ContentGroup4'>
                            {isCVisible && (
                            <div className='historytext1' >
                                <Text variant='px50w800B' className='HistoryYear'>1999 ~ 2011</Text>
                                <div className='HistorySubTitle1'>
                                    <Text variant='px50w600' >창립과 종합설계회사로의 도약</Text>
                                </div>
                                    <div className='imgContainer'>
                                        <img src={imgSample3}/>
                                    </div>
                            </div>
                            )}

                            <div id='scrollPoint1' className='HistorySectionContainer'> 
                                <div className='HistoryContentWrap'>
                                    <div className='HistoryContent1'>

                                        {Object.entries(getGroupByYear4).sort(([keyA], [keyB])=>parseInt(keyB)-parseInt(keyA)).map(arrays => {
                                            const year = arrays[0];
                                            return <div>
                                                <div className='HistoryRow'>
                                                    <span className='HistoryDate'>
                                                        <Text variant='px20w600' >{year}</Text>
                                                    </span>
                                                    <div className='HisContents_Container'>
                                                        {arrays[1].map(array => {
                                                            return <span className='HistoryContents'>
                                                                    <Text variant='px16w400B' style={{ lineHeight : '12px'}}>{array.Contents}</Text>
                                                                </span>  
                                                        })}
                                                    </div>
                                                </div>
                                                <div className='HisContent_LineContainer'>
                                                        <div className='HisContent_Line'> </div>
                                                </div>
                                            </div>
                                        })}

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>

                        </div>
            {/* <div className='HistoryFooter'><img className='footerimg' src={imgHistoryFooter}/></div> */}
            {/*<Footer />*/}
         </div>
     );
 }
 
 export default CompHistory;